import { render, staticRenderFns } from "./ProjectTaxInformationSelector.vue?vue&type=template&id=3851e8c4&scoped=true&"
import script from "./ProjectTaxInformationSelector.vue?vue&type=script&lang=js&"
export * from "./ProjectTaxInformationSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTaxInformationSelector.vue?vue&type=style&index=0&id=3851e8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3851e8c4",
  null
  
)

export default component.exports